"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceWhile = void 0;
function reduceWhile(predicate, callbackfn, initialValue, array) {
    let acc = initialValue;
    for (let i = 0; i < array.length; i++) {
        const value = array[i];
        if (!predicate(acc, value))
            return acc;
        acc = callbackfn(acc, value, i, array);
    }
    return acc;
}
exports.reduceWhile = reduceWhile;
//# sourceMappingURL=reduce_while.js.map